export const menuItemsPadding = 2;

export const finalColumnExtraPadding = "0 16px 0 0";
